// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"no-z","slideIn":"oo-z"};